import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react-links';
import { isInContext, closeWindow } from '../utility/inContextDonation';
import { EVENT_NAME } from '../utility/constants';
import { trackLinkClick } from '../fpti/fpti';
import { LINK_NAME } from '../fpti/fptiConstants';

const DoneLink = ({ doneContent, syncReturnUrl, redirectUrl }) => {
  const handleClose = (event) => {
    event.preventDefault();

    const eventName = EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_DONE_PRESSED;
    trackLinkClick(LINK_NAME.DONE, {
      eventName,
    });

    if (isInContext()) {
      closeWindow();
    }

    // Only redirect when we actually have a return URL. When both URLs are
    // empty (e.g. the Android app webview, where there is no merchant return
    // URL and isInContext() is false), assigning window.location.href = ''
    // reloads the already-completed donate flow and renders the
    // "Your donation was already completed" page. On web this was masked
    // because the SDK popup is closed above.
    const returnUrl = syncReturnUrl || redirectUrl;
    if (returnUrl) {
      window.location.href = returnUrl;
    }
  };

  return (
    <div className="text-center done-link">
      <Link href="#" onClick={handleClose}>
        {doneContent}
      </Link>
    </div>
  );
};

DoneLink.propTypes = {
  doneContent: PropTypes.string,
  syncReturnUrl: PropTypes.string,
  redirectUrl: PropTypes.string,
};

export default DoneLink;
